import {forEach} from "lodash";

export class UploadService {
	/**
	 *
	 * @param $injector
	 * @param $companies
	 * @param $filter
	 */
	constructor($injector, $http, $auth) {
		"ngInject";
		this.$http = $http;
		this.$auth = $auth;
	}

	upload(file, uri = null, contentObject = null,isOverlay) {
		const formData = new FormData();
        formData.append("attachment_file", file);
        formData.append("creator", this.$auth.getUser().url);
		formData.append("content_object", contentObject || "");
        formData.append("is_overlay", isOverlay || false);

		let request = {
            method: "POST",
            url: uri,
            data: formData,
            headers: {
                "content-Type": undefined
            }
        };

		return this.$http(request);
	}

	uploadFew(files, uri = null, contentObject = null, isOverlay) {
        const formData = new FormData();
        forEach(files, (file) => {
            formData.append("attachment_file", file);
        });
        formData.append("creator", this.$auth.getUser().url);
        formData.append("content_object", contentObject || "");
        formData.append("is_overlay", isOverlay || false);

        let request = {
            method: "POST",
            url: uri,
            data: formData,
            headers: {
                "content-Type": undefined
            }
        };

        return this.$http(request);
	}

	delete(uri) {
		return this.$http.delete(uri);
	}

	attachmentId(attachment) {
		if (!attachment || typeof attachment !== "object") {
			return null;
		}
		if (attachment.id) {
			return attachment.id;
		}
		if (attachment.pk) {
			return attachment.pk;
		}
		const url = typeof attachment.url === "string" ? attachment.url : "";
		const match = url.match(/\/attachments\/([^/]+)\/?$/);
		return match ? match[1] : null;
	}

	deleteCompanyAttachment(attachmentsUri, attachment) {
		const id = this.attachmentId(attachment);
		if (!id || !attachmentsUri) {
			return null;
		}
		const base = /\/$/.test(attachmentsUri) ? attachmentsUri : `${attachmentsUri}/`;
		return this.delete(`${base}${id}/`);
	}

}



// WEBPACK FOOTER //
// ./sources/utility/upload/upload.service.js